var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 6.6438C5.05 6.6438 0 11.725 0 18C0 24.275 5.05 29.3563 11.2812 29.3563C17.5125 29.3563 22.5625 24.275 22.5625 18C22.5625 11.725 17.5125 6.6438 11.2812 6.6438ZM29.3 7.3063C26.1875 7.3063 23.6625 12.0938 23.6625 18C23.6625 23.9063 26.1875 28.6938 29.3062 28.6938C32.425 28.6938 34.95 23.9063 34.95 18H34.9375C34.9375 12.0938 32.4125 7.3063 29.3 7.3063ZM38.0187 8.4188C36.925 8.4188 36.0375 12.7063 36.0375 18C36.0375 23.2938 36.925 27.5813 38.0187 27.5813C39.1125 27.5813 40 23.2875 40 18C40 12.7125 39.1125 8.4188 38.0187 8.4188Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBrands);
export default __webpack_public_path__ + "static/media/medium-brands.c03e42c8a8719079464cf72a0225728f.svg";
export { ForwardRef as ReactComponent };